<div *ngIf="!message" style="text-align: center; margin-top: 20px">Completing Single Sign On...</div>
<div *ngIf="message" style="text-align: center; margin-top: 20px">{{message}}</div>
<div *ngIf="napRedirectUrl" style="text-align: center; margin-top: 20px">
    <p>FamAuth setup is required. Use the following link to request access to the WFDSS application:</p>
    <a [href]="napRedirectUrl" target="_blank" rel="noreferrer noopener">Request access</a>
</div>
